import { useState } from 'react';
import PageHeader from '@/components/feature/PageHeader';
import { faqs } from '@/mocks/faqs';
import { usePageMeta } from '@/hooks/usePageMeta';

const jsonLd = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map((f) => ({
    '@type': 'Question',
    name: f.q,
    acceptedAnswer: { '@type': 'Answer', text: f.a },
  })),
};

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  usePageMeta({
    title: '泡在我家的辣妹常见问题 - 剧情与设定答疑',
    description:
      '泡在我家的辣妹常见问题解答：作品讲了什么、核心设定、主要角色、更新与阅读建议，帮你快速答疑。',
    keywords:
      '泡在我家的辣妹常见问题,泡在我家的辣妹剧情,泡在我家的辣妹设定,泡在我家的辣妹问答,泡在我家的辣妹阅读建议',
    canonicalPath: '/faq',
    jsonLd,
  });

  return (
    <>
      <PageHeader
        eyebrow="常见问题"
        icon="ri-question-answer-line"
        title="泡在我家的辣妹常见问题"
        description="关于作品的剧情、核心设定、人物关系与更新节奏，这里整理了读者最常问的问题。点击问题即可展开详细解答。"
        breadcrumbs={[{ label: '首页', to: '/' }, { label: '常见问题' }]}
      />

      <section className="bg-background-50 py-14 md:py-16">
        <div className="container-site">
          <div className="mx-auto max-w-3xl space-y-3">
            {faqs.map((item, idx) => {
              const isOpen = openIndex === idx;
              return (
                <div
                  key={item.q}
                  className="overflow-hidden rounded-lg border border-background-200 bg-background-100"
                >
                  <button
                    type="button"
                    onClick={() => setOpenIndex(isOpen ? null : idx)}
                    aria-expanded={isOpen}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer md:px-6"
                  >
                    <span className="flex items-center gap-3">
                      <span
                        className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-background-50 ${
                          idx % 3 === 0 ? 'bg-primary-500' : idx % 3 === 1 ? 'bg-accent-500' : 'bg-secondary-500'
                        }`}
                      >
                        <i className="ri-question-line text-sm" />
                      </span>
                      <span className="text-sm font-semibold text-foreground-950 md:text-base">{item.q}</span>
                    </span>
                    <i
                      className={`text-foreground-600 transition-transform ${isOpen ? 'rotate-180' : ''} ri-arrow-down-s-line text-xl shrink-0`}
                    />
                  </button>
                  {isOpen && (
                    <div className="px-5 pb-5 pl-16 md:px-6 md:pl-16">
                      <p className="text-sm leading-7 text-foreground-700">{item.a}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>

          <div className="mx-auto mt-10 max-w-3xl rounded-lg border border-primary-200 bg-primary-100 p-6 text-center">
            <p className="text-sm leading-7 text-foreground-800">
              还有没解答的问题？可以先浏览
              <span className="mx-1 font-medium text-primary-700">剧情介绍</span>与
              <span className="mx-1 font-medium text-primary-700">分集剧情</span>，
              大部分疑问都能在完整剧情脉络中找到答案。
            </p>
          </div>
        </div>
      </section>
    </>
  );
}